import { FC } from "react";
import { useTranslation } from "react-i18next";
import { TbTicket } from "react-icons/tb";
import type { Passenger, Segment } from "src/Modules/Flights/constants/JourneyResult";
import PassengerData, { EMPTY_VALUE, formulateSSRs, SSR_MAP } from "./components/PassengerData";

const countFlightsWithExtras = (passengers: Passenger[], segments: Segment[]) => {
  const flights = new Set<string>();
  passengers.forEach((passenger) =>
    Object.values(formulateSSRs(passenger, segments, SSR_MAP)).forEach((ssr) =>
      ssr.segments.forEach((segment, segmentIndex) =>
        segment.flights.forEach(({ value }, flightIndex) => value !== EMPTY_VALUE && flights.add(`${segmentIndex}-${flightIndex}`)),
      ),
    ),
  );
  return flights.size;
};

const TicketDetails: FC<{ passengers?: Passenger[]; segments?: Segment[] }> = ({ passengers = [], segments = [] }) => {
  const { t } = useTranslation();
  const ticketsIssued = passengers.filter((passenger) => passenger.ticketNumber).length;
  const flightsWithExtras = countFlightsWithExtras(passengers, segments);

  return (
    <div className="bg-background-default border-border-subtle flex w-full flex-col overflow-hidden rounded-md border shadow-xs">
      <div className="bg-background-default border-border-subtle flex items-center gap-3 border-b px-6 py-4">
        <div className="bg-background-primary-lighter text-font-active flex size-10 shrink-0 items-center justify-center rounded-md text-xl">
          <TbTicket />
        </div>
        <div className="flex flex-col">
          <div className="text-font-default text-base font-semibold">{t("BookingResult.ticketDetails.sectionTitle")}</div>
          <div className="text-font-subtle text-xs">
            {t("BookingResult.ticketDetails.ticketsIssued", { count: ticketsIssued })}
            {flightsWithExtras > 0 && ` · ${t("BookingResult.ticketDetails.extrasAcross", { count: flightsWithExtras })}`}
          </div>
        </div>
      </div>
      <div className="p-6">
        <PassengerData passengers={passengers} segments={segments} />
      </div>
    </div>
  );
};

export default TicketDetails;
